exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-padding {\n    padding: 0px;\n}\n.ngxmdp .selector {\n  top: 58px !important;\n  left: 14px !important;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/accounts/create/create-account.component.css
// module id = ../../../../../src/app/accounts/create/create-account.component.css
// module chunks = main